import {
  useApolloClient,
  OperationVariables,
  QueryOptions,
  DocumentNode,
  TypedDocumentNode,
} from "@apollo/client";
import { useCallback, useRef, useState } from "react";

export default function useBurstQuery<
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
>(query: DocumentNode | TypedDocumentNode<TData, TVariables>) {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const inFlightCountRef = useRef(0);

  const execute = useCallback(
    async (
      options: Omit<QueryOptions<TVariables, TData>, "query"> = Object.create(
        null,
      ),
    ) => {
      inFlightCountRef.current += 1;
      setLoading(true);
      try {
        return await client.query<TData, TVariables>({ ...options, query });
      } finally {
        inFlightCountRef.current -= 1;
        if (inFlightCountRef.current === 0) {
          setLoading(false);
        }
      }
    },
    [client, query],
  );

  return [execute, { loading }] as const;
}
